import applyConverters from 'axios-case-converter'
import axios from 'axios'
import { appEnvironment } from 'configs'

export default applyConverters(
  axios.create({
    baseURL:
      appEnvironment === 'production' ? `https://api.bookfocal.com/v2` : `https://api.dev.bookfocal.com/v2`,
    responseType: 'json',
    maxContentLength: 'Infinity',
  }),
)
